import { useMutation, useQueryClient } from '@tanstack/react-query';
import { serviceVendorsClient } from '@/services/petseo.service';
import type { CreateServiceVendorServiceRequest } from '@/services/api/petseo.client.wrapper';
import type { ServiceVendorId } from '@/services/api/petseo.client.wrapper';
import { TOAST_MESSAGES, toast, vendorServiceKeys } from '@petseo/shared';
import { usertourService } from '@/services/usertour.service';

export const useCreateService = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ serviceVendorId, data }: { serviceVendorId: ServiceVendorId; data: CreateServiceVendorServiceRequest }) => {
      const response = await serviceVendorsClient.postServiceVendorServiceEndpoint(data, serviceVendorId);
      return response.data;
    },
    onSuccess: (_, { serviceVendorId, data }) => {
      queryClient.invalidateQueries({ queryKey: vendorServiceKeys.forVendor(serviceVendorId) });
      toast.success(TOAST_MESSAGES.SERVICE_CREATED);
      usertourService.track('service_added', { ...data });
    },
    onError: () => toast.error(TOAST_MESSAGES.SERVICE_CREATE_ERROR),
  });
};
